import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert, Button, ModalBody, ModalFooter } from 'reactstrap';

import { OwnedColumn } from './types';

interface ConfirmOverwriteStepProps {
  ownExistingColumns: string[];
  ownedColumns: OwnedColumn[];
  onCancel: () => void;
  onOverwrite: () => void;
}

const ConfirmOverwriteStep: FC<ConfirmOverwriteStepProps> = ({
  ownExistingColumns,
  ownedColumns,
  onCancel,
  onOverwrite,
}) => (
  <>
    <ModalBody>
      <Alert color="warning">
        <FormattedMessage
          id="app.custom_campaign_data.confirm_overwrite.message"
          defaultMessage="The following columns you own already exist. Uploading will overwrite the existing data for these columns."
        />
      </Alert>
      <ul>
        {ownExistingColumns.map((key) => {
          const label = ownedColumns.find((c) => c.key === key)?.label ?? key;
          return <li key={key}>{label}</li>;
        })}
      </ul>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onCancel}>
        <FormattedMessage
          id="app.custom_campaign_data.confirm_overwrite.back"
          defaultMessage="Back"
        />
      </Button>
      <Button color="primary" onClick={onOverwrite}>
        <FormattedMessage
          id="app.custom_campaign_data.confirm_overwrite.confirm"
          defaultMessage="Overwrite"
        />
      </Button>
    </ModalFooter>
  </>
);

export default ConfirmOverwriteStep;
